// FullyDilutedReadout — live FD share count (F1.4). Presentation.
//
// Stage 6e /polish: this is a single hero number — exactly the kind of
// supporting data flow that doesn't need its own container. Drop the .card
// wrapper; let the figure sit open on the page next to the editor. Same
// metric/value typography as before, just without the redundant border.

import { useFullyDilutedShares } from '../../store/selectors';
import { fmtShares } from '../../format/format';

export function FullyDilutedReadout() {
  const fd = useFullyDilutedShares();
  return (
    <div className="panel-open">
      <div className="metric">
        <span className="metric-label">Fully Diluted Shares</span>
        <span className="metric-value">{fmtShares(fd)}</span>
      </div>
    </div>
  );
}
